export * from './baMenuItem.component';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baMenu/components/baMenuItem/index.ts